import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-20'],
    padding: anatomy['space-80'],
    maxWidth: '760px',
  },
  title: {
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    lineHeight: typography['lineHeightBody-4'],
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
  },
  label: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  hint: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightBody-5'],
  },
  summary: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  problemsCount: {
    color: colors.errorText,
  },
  problems: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    color: colors.errorText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-1'],
    paddingLeft: anatomy['space-16'],
  },
  dropZone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '72px',
    padding: anatomy['space-16'],
    border: `1px dashed ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    cursor: 'pointer',
    textAlign: 'center',
  },
  dropZoneActive: {
    borderColor: colors.accentBackground,
    color: colors.primaryText,
  },
  actions: {
    display: 'flex',
    gap: anatomy['space-12'],
  },
  denied: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
  },
});
